class WrongPasswordError extends Error {
    constructor(m?: string) {
        super(m);
    }
}

export default WrongPasswordError;
